<template>
  <div class="relative">
    <saving-overlay v-if="sending" opacity="40"></saving-overlay>
    <div class="p-5">
      <iban
        class=""
        :amount="refill.amounts.total.data"
        :reference="refill.id"
      ></iban>
      <h2
        class="font-bold py-3 text-center"
        v-text="i18n.payment.transfer.proof"
      ></h2>
      <form @submit.prevent="sendProof" class="relative z-1 px-5" v-if="!sent">
        <multiple-file-upload
          :i18n="i18n.payment.transfer.file"
          name="file-upload"
          :required="false"
          :chosen-files="form.documents"
          :errors="form.errors"
          @file-added="addFile"
          @remove="removeFile"
          :max="1"
        ></multiple-file-upload>
        <div class="flex justify-center">
          <ranch-button
            type="submit"
            :label="i18n.payment.transfer.proof"
            :active="formReady"
          ></ranch-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { handleAxiosError } from "@/boot/functions";
import Iban from "../Commons/Billing/Iban";
import { FormWithFiles } from "../Utilities/FormWithFiles";
import MultipleFileUpload from "../Design/Forms/MultipleFileUpload";

export default {
  props: ["refill", "i18n"],
  components: {
    Iban,
    MultipleFileUpload, //VueDropzone: vue2Dropzone,
  },
  mixins: [],
  data: function () {
    return {
      form: new FormWithFiles({
        documents: [],
      }),
      sent: false,
      sending: false,
    };
  },
  methods: {
    sendProof() {
      if (this.formReady) {
        this.sending = true;
        this.form.reset();
        this.form
          .post(this.endpoint)
          .then(({ data }) => {
            this.sent = true;
            this.$emit("proof-sent", data);
          })
          .catch(handleAxiosError)
          .then(() => {
            this.sending = false;
          });
      }
    },
    addFile(file) {
      this.form.reset();
      this.form.documents.push(file);
    },
    removeFile(key) {
      this.form.reset();
      this.form.documents.splice(key, 1);
    },
  },
  computed: {
    endpoint() {
      return this.refill.routes.send_proof;
    },
    formReady() {
      return this.form.documents.length === 1;
    },
  },
  mounted() {},
};
</script>
